<!-- router outlet start -->
<router-outlet></router-outlet>
<!-- router outlet end -->

<!-- back to top start -->
<app-back-to-top></app-back-to-top>
<!-- back to top end -->

<!-- product modal start -->
<app-product-modal></app-product-modal>
<!-- product modal end -->


